import React from 'react';
import { havanStore } from './havan-store';

export const useHavanStore = (id: string) => {
  const [, render] = React.useState(0);
  havanStore.onChange(id, () => {
    render((prev) => prev + 1);
  });
};
